import React, { useState, useMemo } from 'react';
import { SegmentedControl } from '@mantine/core';
import AdminGrid from './AdminGrid';
import { UPDATE_COLLECTION_FIELD } from '../mutations';
// import moment from 'moment';
// import AntdDatePickerEditor from './AntdDatePickerEditor';
import { useHistory } from 'react-router-dom';

const projectColumns = [
  { field: 'name', headerName: 'Name', editable: true, width: 400 },
  //   { field: 'clientName', headerName: 'Client Name', editable: true, width: 180 },
  { field: 'description', headerName: 'Description', editable: true, width: 500 },
  { field: 'projectCode', headerName: 'Project Code', editable: true, width: 120 },
  { field: 'owner', headerName: 'Owner', editable: true, width: 150 },
  { field: 'status', headerName: 'Status', editable: true, width: 120 },
  //   { field: 'practice', headerName: 'Practice', editable: true, width: 120 },
  //   { field: 'sectors', headerName: 'Sectors', editable: true, width: 150 },
  //   { field: 'solution', headerName: 'Solution', editable: true, width: 120 },
  //   { field: 'billing', headerName: 'Billing', editable: true, width: 120 },
  //   { field: 'complete', headerName: 'Complete', editable: true, width: 100 },
  { field: 'budget', headerName: 'Budget', editable: true, width: 120, type: 'number' },
  //   { field: 'proposedBudget', headerName: 'Proposed Budget', editable: true, width: 140, type: 'number' },
  // { field: 'totalCost', headerName: 'Total Cost', editable: true, width: 120, type: 'number' },
  // {
  //   field: 'totalApprovedHours',
  //   headerName: 'Total Approved Hours',
  //   editable: true,
  //   width: 160,
  //   type: 'number',
  // },
  {
    field: 'totalBilledAmount',
    headerName: 'Total Billed Amount',
    editable: true,
    width: 160,
    type: 'number',
  },
  {
    field: 'actualHoursRemaining',
    headerName: 'Actual Hours Remaining',
    editable: true,
    width: 180,
    type: 'number',
  },
  // {
  //   field: 'startDate',
  //   headerName: 'Start Date',
  //   editable: true,
  //   width: 130,
  //   type: 'date',
  //   valueFormatter: params => (params.value ? moment(params.value).format('YYYY-MM-DD') : ''),
  //   cellEditorFramework: AntdDatePickerEditor,
  // },
  // {
  //   field: 'estimatedEndDate',
  //   headerName: 'Estimated End Date',
  //   editable: true,
  //   width: 160,
  //   type: 'date',
  //   valueFormatter: params => (params.value ? moment(params.value).format('YYYY-MM-DD') : ''),
  //   cellEditorFramework: AntdDatePickerEditor,
  // },
  // {
  //   field: 'endDate',
  //   headerName: 'End Date',
  //   editable: true,
  //   width: 130,
  //   type: 'date',
  //   valueFormatter: params => (params.value ? moment(params.value).format('YYYY-MM-DD') : ''),
  //   cellEditorFramework: AntdDatePickerEditor,
  // },
];

const userColumns = [
  { field: 'profile.firstName', headerName: 'First Name', editable: true, width: 175 },
  { field: 'profile.lastName', headerName: 'Last Name', editable: true, width: 175 },
  {
    field: 'profile.emails.0.address',
    headerName: 'Email',
    editable: false,
    width: 250,
    valueGetter: params => params.data?.emails?.[0]?.address || '',
  },
  { field: 'profile.role', headerName: 'Role', editable: true, width: 150 },
  { field: 'profile.employeeType', headerName: 'Employee Type', editable: true, width: 150 },
  { field: 'profile.workCalendar', headerName: 'Work Calendar', editable: true, width: 200 },
  { field: 'profile.payrollId', headerName: 'Payroll ID', editable: true, width: 120 },
];

const QuickEdit = ({ initialSegment = 'projects' }) => {
  const [segment, setSegment] = useState(initialSegment);
  const history = useHistory();

  const gridProps = useMemo(() => {
    if (segment === 'projects') {
      return {
        collectionName: 'projects',
        columns: projectColumns,
        mutation: UPDATE_COLLECTION_FIELD,
        idField: '_id',
        variables: { offset: 0, limit: 1000 },
      };
    } else {
      return {
        collectionName: 'users',
        columns: userColumns,
        mutation: UPDATE_COLLECTION_FIELD,
        idField: '_id',
        variables: { offset: 0, limit: 1000 },
      };
    }
  }, [segment]);

  return (
    <div>
      <div className="flex items-center justify-between w-full mb-2">
        <h2>Update Updates</h2>
        <SegmentedControl
          data={[
            { label: 'Projects', value: 'projects' },
            // { label: 'Users', value: 'users' },
          ]}
          value={segment}
          onChange={value => {
            setSegment(value);
            history.push(`/admin/quick-edit/${value}`);
          }}
          style={{ maxWidth: 300 }}
        />
      </div>
      <AdminGrid {...gridProps} />
    </div>
  );
};

export default QuickEdit;
